import { render, staticRenderFns } from "./frictionless.vue?vue&type=template&id=66022160"
import script from "./frictionless.vue?vue&type=script&lang=js"
export * from "./frictionless.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66022160')) {
      api.createRecord('66022160', component.options)
    } else {
      api.reload('66022160', component.options)
    }
    module.hot.accept("./frictionless.vue?vue&type=template&id=66022160", function () {
      api.rerender('66022160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/frictionless.vue"
export default component.exports